import { ThemeTemplatesApi } from '../../generated/api';
import configuration from './configuration';

export default new ThemeTemplatesApi(configuration);
